// extracted by mini-css-extract-plugin
export default {"menuButton":"menu_menuButton__M4sHl","select":"menu_select__czpsI"};